import * as React from 'react'
import {configOptions} from './config-options'


export const TablePlusPlusPOCDescription = {
  name: 'Table++ POC',
  component: React.lazy(() => import('./TablePlusPlus' )),
  label: 'Table++ (AMS poc version)',
  variables: configOptions,
}
